<template>
  <transition name="fade" v-bind="$attrs">
    <slot/>
  </transition>
</template>

<script>
export default {
}
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
  @include transition(opacity .3s);
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
